import script from "./rec-progress-area.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-progress-area.vue?vue&type=script&lang=ts&setup=true"

import "./rec-progress-area.vue?vue&type=style&index=0&id=a39ded9a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a39ded9a"]])

export default __exports__